import { DateText } from './DateText';

/** Relative label ("12 days ago") with the full date tooltip on hover. */
export const When = (props: { date: string | null | undefined; class?: string }) => (
  <DateText
    value={props.date}
    format="relative"
    empty=""
    class={props.class ?? 'shrink-0 text-xs text-neutral-400'}
  />
);
